export default {
  baseStyle: {
    color: 'default.2',
  },
  sizes: {
    sm: 'small',
    lg: 'large',
  },
  defaultProps: {
    size: 'large',
  },
};
